module.exports = "<div class=\"progress-bar-container\" *ngIf=\"progress!='0'\">\n  <div class=\"progress-bar\" [style.width]=\"progress+'%'\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/progress-bar/progress-bar.component.html
// module id = ./src/app/components/shared/progress-bar/progress-bar.component.html
// module chunks = main